import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import config from './config';

const bootstrapShell = document.getElementById('app-bootstrap-shell');
if (bootstrapShell) bootstrapShell.remove();

function getReturnUrl() {
    return `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`;
}

function redirectToApiLogin() {
    const params = new URLSearchParams(window.location.search);
    const loginHint = params.get('login_hint')
        || params.get('loginHint')
        || params.get('upn')
        || params.get('email')
        || config.authentication.loginHint;

    const loginUrl = new URL('/api/auth/login', config.csharpBackendUrl);
    loginUrl.searchParams.set('returnUrl', getReturnUrl());
    if (loginHint) {
        loginUrl.searchParams.set('loginHint', loginHint);
    }

    window.location.assign(loginUrl.toString());
}

async function hasApiSession() {
    const sessionUrl = new URL('/api/auth/session', config.csharpBackendUrl);
    const response = await fetch(sessionUrl.toString(), {
        credentials: 'include',
        headers: { accept: 'application/json' },
    });

    return response.ok;
}

async function bootstrap() {
    if (!(await hasApiSession())) {
        redirectToApiLogin();
        return;
    }

    createRoot(document.getElementById('root')).render(
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
}

bootstrap().catch((error) => {
    console.error('Failed to start app', error);
    redirectToApiLogin();
});
